module.exports = __webpack_public_path__ + "static/img/banner-empleo-home-1680x1050.e09db01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleo-home-1680x1050.jpg
// module id = 6R/t
// module chunks = 47